var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full md:bg-white"},[_c('AlertBanner',{attrs:{"page":_vm.orgOwnerPage,"slug":_vm.orgOwnerSlug}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }